(function() {
    var freshopUiEvents = freshop.ui.events = {},
        eventNs,
        allowedOnEvents = {
            LOADED: true,
            SEARCH_BEFORE_CHANGE: true,
            SEARCH: true,
            RENDERED: true,
            ROUTE_CHANGED: true,
            TRACK_EVENT: true,
            MODAL_SHOWN: true,
            MODAL_HIDDEN: true
        },
        allowedTriggerEvents = {
            INITIALIZE: true,
            RESIZE: true,
            MODULE_LOAD: true,
            TRACK_EVENT: true
        },
        on = {},
        trigger = {};

    fp.clientUiEvents = {
        on: on,
        trigger: trigger
    };

    _.each(allowedOnEvents, function(value, key) {
        if(_.isString(value)) eventNs = value;
        else eventNs = fp.events[key];

        freshopUiEvents[key] = eventNs;
        on[eventNs] = true;
    });

    _.each(allowedTriggerEvents, function(value, key) {
        if(_.isString(value)) eventNs = value;
        else eventNs = fp.events[key];

        freshopUiEvents[key] = eventNs;
        trigger[eventNs] = true;
    });
})();